import {Request} from './Request';

export class ReserveNowRequest implements Request {
    chargePointSelectList: string[];
    private connectorId: string;
    private idTag: string;
    private expiry: Date;

    constructor(chargePointSelectList: string[], connectorId?: string, idTag?: string, expiry?: Date) {
        this.chargePointSelectList = chargePointSelectList;
        this.connectorId = connectorId;
        this.idTag = idTag;
        this.expiry = expiry;
    }

    public toString = (): string => {
        return `ReserveNowRequest (expiry: ${this.expiry},
        idTag: ${this.idTag}, connectorId: ${this.connectorId},
        chargePointSelectList: ${this.chargePointSelectList})`;
    }

    get connector_id(): string {
        return this.connectorId;
    }

    set connector_id(value: string) {
        this.connectorId = value;
    }

    get id_tag(): string {
        return this.idTag;
    }

    set id_tag(value: string) {
        this.idTag = value;
    }

    get expiry_date(): Date {
        return this.expiry;
    }

    set expiry_date(value: Date) {
        this.expiry = value;
    }
}
